import React from 'react'
import { INQUIRED_STATUS_REASON_OPTIONS } from '../utilityFunctions'
import './inquired-reason-popup.css'

const InquiredReasonPopup = ({ title, onConfirm, onCancel }) => {
  const [selectedReason, setSelectedReason] = React.useState('')

  return (
    <div className="inquired-reason-popup__backdrop" onMouseDown={onCancel}>
      <div className="inquired-reason-popup__modal" onMouseDown={(event) => event.stopPropagation()}>
        <div className="inquired-reason-popup__title">{title}</div>
        <div className="inquired-reason-popup__subtitle">
          Select one reason for changing this status to Inquired.
        </div>
        <div className="inquired-reason-popup__options">
          {INQUIRED_STATUS_REASON_OPTIONS.map((option) => (
            <label key={option} className="inquired-reason-popup__option">
              <input
                type="radio"
                name="inquired-reason"
                value={option}
                checked={selectedReason === option}
                onChange={(event) => setSelectedReason(event.target.value)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
        <div className="inquired-reason-popup__actions">
          <button type="button" className="inquired-reason-popup__button is-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="inquired-reason-popup__button is-primary"
            onClick={() => onConfirm(selectedReason)}
            disabled={!selectedReason}
          >
            Save Reason
          </button>
        </div>
      </div>
    </div>
  )
}

export default InquiredReasonPopup
